import { CancelToken, isCancel } from 'axios'

export const getters = {
  find: state => id => state.active.find(opportunity => opportunity.id == id),
  isOpen: (state, getters) => (id, useCommencedAt = false) => {
    const opportunity = getters.find(id)
    if (!opportunity) return false

    const now = new Date()
    const deadline = useCommencedAt ? opportunity.commencesAt : opportunity.closesAt

    return !!(
      opportunity &&
      opportunity.opensAt &&
      deadline &&
      new Date(opportunity.opensAt) < now &&
      new Date(deadline) > now
    )
  },
}

export default {
  namespaced: true,

  state: {
    // The Opportunities currently visible
    active: [],
    // What filters are currently applied
    filters: {},
    // Used to indicate when waiting on the server
    loading: false,
    // The current page being viewed
    page: 1,
    // Size of current page beign viewed
    rowsPerPage: 10,
    // The search string being applied
    search: '',
    // Sorting
    sort: {
      by: 'distance_in_meters',
      descending: false,
    },
    // Token source used to abandon requests
    source: null,
    // The total records matching the filter according to the server (for pagination)
    total: 0,
  },

  getters,

  mutations: {
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = { by: 'distance_in_meters', descending: true },
        filters = {},
      }
    ) {
      state.search = search
      state.active = items
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
      state.selected = []
    },

    set(state, opportunity) {
      const find = state.active.find(o => o.id == opportunity.id)
      if (find) state.active.splice(state.active.indexOf(find), 1, opportunity)
      if (!find) state.active.push(opportunity)
    },

    clearActive(state) {
      state.active = []
    },
  },

  actions: {
    search(
      { commit, state },
      { descending, filters, opportunity, page, search, rowsPerPage, sortBy, location } = {}
    ) {
      if (state.source) {
        state.source.cancel()
      }
      state.source = CancelToken.source()
      filters = filters || state.filters
      page = page || state.page
      const per = rowsPerPage || state.rowsPerPage
      sortBy = sortBy || state.sort.by
      const sort = `${sortBy} ${descending ? 'DESC' : 'ASC'}`
      const { latitude, longitude } = location || {}

      state.loading = true
      return Vue.$http
        .get(`candidate/opportunities`, {
          params: { ...filters, page, search, sort, per, latitude, longitude },
          cancelToken: state.source.token,
        })
        .then(
          response => {
            commit('setActive', response.data)
            return response
          },
          errors => {
            if (!isCancel(errors)) state.loading = false
          }
        )
    },

    updateFiltersAndSearch({ dispatch, state }, { filters = {}, search = '' }) {
      if (filters) {
        state.filters = state.filters ? state.filters : {}
        Object.assign(state.filters, { ...filters })
      }
      return dispatch('search', { search }).then(response => response)
    },

    checkEligibility({ commit }, opportunity) {
      if (!opportunity) return
      return Vue.$http
        .get(`candidate/opportunities/${opportunity.id}/eligibility`)
        .then(response => {
          commit('set', Object.assign({}, opportunity, { eligibility: response.data }))
          return response
        })
    },

    apply({ commit, dispatch }, { opportunity, locations }) {
      return Vue.$http.post(`candidate/opportunities/${opportunity.id}/apply`, {
        locations,
      })
    },
  },
}
